// @ts-nocheck

import React from 'react';

import HistoryItemOutcomeDefaultContent from '../HistoryItemOutcomeDefaultContent';
import HistoryItemOutcomeMyMatchContent from '../HistoryItemOutcomeMyMatchContent';

const HistoryItemOutcomeContentFactory = (props) => {
  if (props.isMyMatch) {
    return <HistoryItemOutcomeMyMatchContent {...props} />;
  } else {
    return <HistoryItemOutcomeDefaultContent {...props} />;
  }
};

export default HistoryItemOutcomeContentFactory;
